import type { ReactNode } from "react";
import { useBusiness, switchBusiness, MASTER_ID } from "../lib/business";

// Wraps an Outreach page that only makes sense in Master or only inside a company,
// and offers the switch instead of rendering an empty or refused page.
export default function Scope({ need, children }: { need: "master" | "company"; children: ReactNode }) {
  const { businesses, isMaster } = useBusiness();
  if (need === "master" && isMaster) return <>{children}</>;
  if (need === "company" && !isMaster) return <>{children}</>;

  const path = window.location.pathname + window.location.search;
  return (
    <div className="card mx-auto mt-10 max-w-lg p-6 text-center">
      {need === "company"
        ? <>
            <div className="text-base font-semibold text-slate-900">This page belongs to a company</div>
            <p className="mt-1 text-sm text-slate-500">Contacts and logs are kept separately for each company. Choose one:</p>
            <div className="mt-4 flex justify-center gap-2">
              {businesses.map(b => (
                <button key={b.id} className="btn-secondary" onClick={() => switchBusiness(b.id, path)}>{b.name}</button>
              ))}
            </div>
          </>
        : <>
            <div className="text-base font-semibold text-slate-900">This page is in Master</div>
            <p className="mt-1 text-sm text-slate-500">Roles, research, templates, senders and import are shared and managed in Master.</p>
            <div className="mt-4">
              <button className="btn-primary" onClick={() => switchBusiness(MASTER_ID, path)}>Go to Master</button>
            </div>
          </>}
    </div>
  );
}
